import styled, { css, keyframes } from 'styled-components'
// eslint-disable-next-line no-unused-vars
import { IVariant } from '../../interfaces/toast'

interface IContainer {
  variant: IVariant
}

const show = keyframes`
  0% {
    opacity: 0;
    transform: translateX(100%);
  } 80% {
    opacity: 1;
    transform: translateX(-5%);
  } 100% {
    transform: translateX(0%);
  }
`

const close = keyframes`
  0% {
    transform: translateX(0%);
    opacity: 1;

  } 15% {
    transform: translateX(-5%);
  } 100% {
    transform: translateX(100%);
    opacity: 0;
  }
`

export const Container = styled.div<IContainer>`
  width: fit-content;
  min-width: 300px;
  max-width: 420px;

  position: relative;

  padding: 1rem 1rem 1rem 0;

  margin-bottom: 1rem;

  box-shadow: var(--toast-shadow);

  border-radius: 2px;

  &.show {
    animation: ${show} 0.5s linear both;
  }

  &.close {
    animation: ${close} 0.5s linear both;
  }

  ${(props) =>
    props.variant === 'info' &&
    css`
      background: var(--toast-background);
      color: var(--toast-color);
      border: var(--toast-border);
    `}

  ${(props) =>
    props.variant === 'success' &&
    css`
      background: var(--toast-success-background);
      color: var(--toast-success-color);
      border: var(--toast-success-border);
    `}

  ${(props) =>
    props.variant === 'warning' &&
    css`
      background: var(--toast-warning-background);
      color: var(--toast-warning-color);
      border: var(--toast-warning-border);
    `}

 ${(props) =>
    props.variant === 'error' &&
    css`
      background: var(--toast-error-background);
      color: var(--toast-error-color);
      border: var(--toast-error-border);
    `}

  &:last-child {
    margin-bottom: 0;
  }

  header {
    display: flex;

    i {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      width: 54px;
      font-size: 1.2rem;
    }

    strong {
      display: flex;
      align-items: center;
    }
  }

  p {
    margin-left: 54px;
  }
`

interface IProgress {
  variant: IVariant
  timeout: number
}

const progress = keyframes`
  0% {
    width: 0%;
  } 100% {
    width: 100%;
  }
`

export const Progress = styled.div<IProgress>`
  position: absolute;
  bottom: 0;
  left: 0;

  width: 50%;

  border-radius: 1px;
  border-bottom: 4px solid black;

  animation: ${progress} ${(props) => `${props.timeout}ms`} linear both;

  ${(props) =>
    props.variant === 'info' &&
    css`
      border-color: var(--toast-color);
    `}

  ${(props) =>
    props.variant === 'success' &&
    css`
      border-color: var(--toast-success-color);
    `}

  ${(props) =>
    props.variant === 'warning' &&
    css`
      border-color: var(--toast-warning-color);
    `}

 ${(props) =>
    props.variant === 'error' &&
    css`
      border-color: var(--toast-error-color);
    `}
`
